import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as Menu from '../../components/menu'
import * as RootConstants from '../../constants'
import * as Request from '../../request'
import * as Router from '../../router'
import * as Auth from '../auth/utils'
import * as Constants from './constants'

declare const RASA_DASHBOARD_HOME_PAGE: string

export const contentInit: ReduxObservable.Epic<Redux.Action, any> = (action$, store, {history}) =>
  action$.ofType(App.INITIALIZING_APPLICATION)
    .filter(() => !Auth.pageNeedsAuthentication(history))
    .map(() => ({type: App.CONTENT_INIT}))

export const handleDashboardLogin = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<any>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(Request.successConstant(Constants.USER_LOGIN))
.filter((action) => action.payload.response.access_token.startsWith('DASHBOARD_ACCESS_TOKEN'))
.map((action) => Router.redirect(
  `${RASA_DASHBOARD_HOME_PAGE}?RASA_AUTH_TOKEN=${action.payload.response.access_token.split('|')[1]}`))

export const handleLogin = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<any>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(Request.successConstant(Constants.USER_LOGIN))
.filter((action) => !action.payload.response.access_token.startsWith('DASHBOARD_ACCESS_TOKEN'))
.map((action) => localStorage.setItem(RootConstants.ACCESS_TOKEN, action.payload.response.access_token))
.map(() => Router.redirect(Menu.AUTH_LOGIN_VALIDATION_URL))

export const handleLoginError = (
  action$: ReduxObservable.ActionsObservable<any>,
) => action$.ofType(Request.errorConstant(Constants.USER_LOGIN))
  .mapTo(Flash.showFlashError('The username or password you entered is invalid'))

export const handleExpireError = (
  action$: ReduxObservable.ActionsObservable<any>,
) => action$.ofType(Request.errorConstant(Constants.USER_LOGIN))
  .filter((action) => action.payload.error.status === 410)
  .map(() => window.location.href = Constants.EXPIRE_REDIRECT_URL)

export const epic = ReduxObservable.combineEpics(
  contentInit,
  handleDashboardLogin,
  handleExpireError,
  handleLogin,
  handleLoginError,
)



// WEBPACK FOOTER //
// ./src/pages/oauth-login/epic.ts